import * as React from 'react';
import PropTypes from 'prop-types';

import { DropdownField, TextField, FormInput } from '../static/Inputs';
import {Button} from '../static/Elements';
import Icon from '../static/Icons';
import RichTextEditor from 'react-rte';
import CurrencyInput from 'react-currency-input';
import DatePicker from 'react-datepicker/es';

import 'react-datepicker/dist/react-datepicker.css';
import 'draft-js-static-toolbar-plugin/lib/plugin.css';
import createLogger from '../../utils/createLogger';
import {createDidError, createIsLoading} from "../../data/requests/requestsSelectors";
import {connect} from "react-redux";
import {
  getJobDetails,
  getPostings,
  editContacts,
} from "../../data/jobs/jobActions";
import {createOpenWebJobSelector} from "../../data/owp/owpSelectors";
import {promoteOpenWebJob} from "../../data/owp/owpActions";

const DEBUG = true;
const debug = createLogger(DEBUG, `JobDetails.js`);

class OpenWebPromotionForm extends React.Component {

  static dependencies = [
    `GET_JOB_POSTINGS_PAGE`,
    `GET_JOB`,
    `PUT_JOB`,
    'POST_JOB',
  ];

  static propTypes = {
    get: PropTypes.func.isRequired,
    didError: PropTypes.bool,
    isLoading: PropTypes.bool,
    closeModal: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      editorValue: RichTextEditor.createValueFromString(this.props.job.description, 'html'),
      editMode: false,
      contacts: [],
      jobData: this.emptyJobData(),
      initialized: false,
    };
  }

  emptyJobData = () => ({
    agency: '',
    contact_id: '',
    lead_date: new Date(),
    title: this.props.job.title,
    employment_type: 'Direct Hire',
    match_url: this.props.matchUrl || '',
    company: this.props.job.company || '',
    duration: this.props.job.duration || null,
    careers_page: this.props.job.careers_page,
    company_id: this.props.job.company_id || null,
    min_salary: this.props.job.min_salary || null,
    max_salary: this.props.job.max_salary || null,
    hourly_pay: this.props.job.hourly_pay || null,
    min_experience: this.props.job.min_experience || null,
  });

  onInputChange = (field) => (input) => {
    debug.log(`setting ${field} to ${input}`, input);
    this.setState({jobData: {...this.state.jobData, [field]: input}});
  };

  onContactChange = (i, field) => (input) => {
    debug.log(`setting index ${i} to ${input}`);
    const {contacts} = this.state;
    contacts[i][field] = input;
    contacts[i]['is_changed'] = true;
    this.setState({contacts})
  };

  onTextChange = (value) => {
    this.setState({editorValue: value});
  };

  onRadioChange = (e) => {
    debug.log(`setting contact_id to ${e.target.value}`);
    this.setState({jobData: {...this.state.jobData, contact_id: e.target.value}});
  };

  toggleEditMode = () => {
    const { contacts } = this.props.job;
    const { editMode } = this.state;
    if (editMode === false) {
      let contact_array = [];
      contacts.forEach ((contact) => {
        let contact_obj = {
          contactid: contact['contactid'],
          contactname: contact['contactname'] || contact['firstname'] + ' ' + contact['lastname'],
          position: contact['position'],
          linkedinaddress: contact['linkedinaddress'],
          email: contact['email'],
          phonenumber: contact['phonenumber'],
          isdeleted: false,
          is_changed: false,
        };
        contact_array.push (contact_obj);
        this.setState({contacts: contact_array, editMode: true});
      })
    } else {
      console.log(this.state.contacts);
      console.log(this.state.jobData.contact_id);
      this.setState({editMode: false});
    }
  };

  handleContactEdits = (e) => {
    e.preventDefault();
    const {editContacts, job} = this.props;
    const {contacts} = this.state;
    let id = job.company_id;
    editContacts(id, contacts)
      .then(() => {
        this.toggleEditMode();
        this.setState({contacts})
      })
      .catch((error) => {
        debug.log(error);
      });
  };

  removeContact = (index) => () => {
    const {contacts} = this.state;
    debug.log('Removing contact at index: ', index);
    debug.log(this.state.contacts[index]);
    contacts[index]['isdeleted'] = true;
    this.setState({
      contacts: contacts
    })
  };

  styleDescription = (description) => {
    let opening_div = `<div style='font-family: Arial, Helvetica, sans-serif; font-size: 14px;'>`;
    let closing_div = `</div>`;
    let new_description = opening_div + description + closing_div;
    debug.log(new_description);
    return new_description
  };

  promote = (e) => {
    e.preventDefault ();
    const {job} = this.props;
    console.log (job);
    const {closeModal, promoteOpenWebJob, selectNext} = this.props;
    let config = this.state.jobData;
    let description_html = this.state.editorValue.toString ('html');
    config['description_html'] = this.styleDescription (description_html);
    config['openweb'] = 'promoted';
    console.log ('promoting...');
    closeModal ();
    selectNext ();
    promoteOpenWebJob (job.id, config);
  };

  onCancel = () => {
    this.emptyJobData();
    this.props.closeModal();
  };

  render () {
    const {job} = this.props;
    const deltaContacts = this.state.contacts;
    const {contacts, company} = job;
    const { editMode, editorValue } = this.state;
    const {
      title,
      agency,
      lead_date,
      employment_type,
      min_salary,
      max_salary,
      min_experience,
      duration,
      hourly_pay,
      careers_page,
      match_url,
      contact_id,
    } = this.state.jobData;

    const {
      onInputChange,
      toggleEditMode,
      handleContactEdits,
      promote,
      onTextChange,
      removeContact,
      onRadioChange,
      onCancel,
      onContactChange,
    } = this;

    const titleFieldConfig = {
      type: `text`,
      value: title,
      label: 'Job Title',
      placeholder: 'Sr. Developer',
      onChange: onInputChange(`title`),
    };

    const agencyFieldConfig = {
      type: `text`,
      value: agency,
      label: 'Agency',
      onChange: onInputChange(`agency`),
    };

    const companyFieldConfig = {
      type: `text`,
      value: company,
      label: 'Company',
      readOnly: true,
    };

    const datePickerConfig = {
      selected: lead_date,
      name: 'lead_date',
      label: 'Agency Leads Date',
      onChange: onInputChange('lead_date'),
      className: `date-picker-field`,
      todayButton: 'Today',
    };

    const employmentTypeConfig = {
      type: 'text',
      value: employment_type,
      label: "Type",
      onChange: onInputChange(`employment_type`),
      defaultValue: 'Direct Hire',
    };

    const matchUrlConfig = {
      type: 'text',
      label: 'Match URL',
      onChange: onInputChange('match_url'),
      value: match_url,
    };

    const careersPageConfig = {
      type: 'text',
      label: 'Company Careers Page URL',
      onChange: onInputChange('careers_page'),
      value: careers_page,
    };

    const toolbarConfig = {
      display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
      INLINE_STYLE_BUTTONS: [
        {label: 'Bold', style: 'BOLD', className: 'rte-toolbar'},
        {label: 'Italic', style: 'ITALIC'},
        {label: 'Underline', style: 'UNDERLINE'}
      ],
      BLOCK_TYPE_DROPDOWN: [
        {label: 'Normal', style: 'unstyled'},
        {label: 'Heading Large', style: 'header-one'},
        {label: 'Heading Medium', style: 'header-two'},
        {label: 'Heading Small', style: 'header-three'}
      ],
      BLOCK_TYPE_BUTTONS: [
        {label: 'UL', style: 'unordered-list-item'},
        {label: 'OL', style: 'ordered-list-item'}
      ]
    };

    return (
      <FormInput className='promotion-form-container'>

        <div className='text-area-container editorStyles.editor' onClick={this.focus}>
          <RichTextEditor value={editorValue}
                          onChange={onTextChange}
                          toolbarConfig={toolbarConfig}
                          className='rte-textarea'/>
        </div>

        <div className='promotion-form-fields'>

          <div className='full-line-field'>
            <TextField {...titleFieldConfig} />
          </div>

          <div className='split-line-field'>
            <TextField {...agencyFieldConfig} />
            <TextField {...companyFieldConfig} />
          </div>

          <div className='split-line-field'>
            <div>
              <label>Lead Date</label>
              <DatePicker {...datePickerConfig} />
            </div>
            <DropdownField {...employmentTypeConfig}>
              <option value='Direct Hire' className={'dropdown-item'}>Direct Hire</option>
              <option value='Contract' className={"dropdown-item"}>Contract</option>
              <option value='Contract To Direct Hire' className={"dropdown-item"}>Contract to Direct Hire</option>
              <option value='Contract, Direct Hire, Contract To Direct Hire' className={"dropdown-item"}>All</option>
            </DropdownField>
          </div>

          {
            employment_type !== 'Direct Hire'
            ? (
                <div className='split-line-field'>
                  <div>
                    <label>Duration</label>
                    <CurrencyInput value={duration} precision='0' suffix=' months'
                                   onChangeEvent={(e, fv, v) =>
                                   {this.setState({jobData: {...this.state.jobData, duration: v}})}}/>
                  </div>
                  <div>
                    <label>Hourly Pay</label>
                    <CurrencyInput value={hourly_pay}
                                   onChangeEvent={(e, fv, v) =>
                                   {this.setState({jobData: {...this.state.jobData, hourly_pay: v}})}}
                                   prefix='$' precision='0' suffix='/hr'/>
                  </div>
                </div>
              )
            : null
          }

          <div className='thirds-line-field'>
            <div>
              <label>Min Salary</label>
              <CurrencyInput value={min_salary}
                             onChangeEvent={(e, fv, v) =>
                             {this.setState({jobData: {...this.state.jobData, min_salary: v}})}}
                             prefix='$' precision='0'/>
            </div>
            <div>
              <label>Max Salary</label>
              <CurrencyInput value={max_salary}
                             onChangeEvent={(e, fv, v) =>
                             {this.setState({jobData: {...this.state.jobData, max_salary: v}})}}
                             prefix='$' precision='0'/>
            </div>
            <div>
              <label>Min Experience</label>
              <CurrencyInput value={min_experience}
                             onChangeEvent={(e, fv, v) =>
                             {this.setState({jobData: {...this.state.jobData, min_experience: v}})}}
                             suffix=' years' precision='0'/>
            </div>
          </div>

          <div className='full-line-field'>
            <TextField {...matchUrlConfig} />
          </div>

          <div className='full-line-field'>
            <TextField {...careersPageConfig} />
          </div>
          {
            contacts ? (
              <div className='contacts-selector-container'>
                <h5>Contacts</h5>
                {
                  editMode ?
                    <div/> : (
                      <Button type="theme-light" onClick={toggleEditMode}>
                        Edit Contacts
                      </Button>
                    )
                }

                <div className='contact-list'>
                  {
                    editMode ? (
                      <div>
                        {
                          deltaContacts.map ((contact, index) => (
                            <ContactListItem i={index} editable={true}
                                             key={contact['contactid']}
                                             contact={contact} onChange={onContactChange}
                                             onRemove={removeContact (index)}/>
                          ))
                        }
                      </div>
                    ) : (
                      <div>
                        {
                          contacts.map (contact => (
                            <ContactListItem key={contact['contactid']}
                                             contact={contact} selectedContact={contact_id}
                                             onChange={onRadioChange}/>
                          ))
                        }
                      </div>
                    )
                  }
                </div>
              </div>) : null
          }
          {
            editMode ? (
              <div className='form-footer'>
                <Button key='1' danger onClick={toggleEditMode}>Cancel</Button>
                <Button key='2' primary onClick={handleContactEdits}>Save</Button>
              </div>
            ) : (
              <div className='form-footer'>
                <Button key='3' danger onClick={onCancel}>Cancel</Button>
                <Button key='4' primary onClick={promote}>Promote</Button>
              </div>
            )}
        </div>
      </FormInput>
    )
  }
}

const ContactListItem = ({i, editable=false, contact, selectedContact, onChange, onRemove}) => {
  let name;
  if (contact['contactname'] === null) {
    name = contact['firstname'] + ' ' + contact['lastname'];
  } else {
    name = contact['contactname']
  }
  if (contact['isdeleted']) {
    return null
  }
  if (editable === false) {
    return (
      <div className='contact-list-item'>
        <input type='radio' name='contact' value={contact['contactid']}
               checked={parseInt(selectedContact, 10) === contact['contactid']} onChange={onChange}/>
        <div className='contact-list-item-box'>
          <div className='contact-list-item-text'>
            <p className='no-margin'>
              {contact['position']} ({name})</p>
            <a href="#" onClick={()=>window.open(contact['linkedinaddress'])}>{contact['linkedinaddress'] || ''}</a>
          </div>
          <div/>
        </div>
      </div>
    )
  } else {
    return (
      <div className='contact-list-item'>
        <div className='contact-list-item-box'>
          <div className='edit-contact-item'>
            <p>{name}</p>
            <TextField onChange={onChange(i, 'position')} value={contact['position']}/>
            <TextField onChange={onChange(i, 'linkedinaddress')} value={contact['linkedinaddress']}/>
          </div>
          <div className='edit-mode-options'>
            <Button type='button' key='5' small action danger onClick={onRemove}><Icon.Trash/></Button>
          </div>
        </div>
      </div>
    )
  }
};


const mapStateToProps = (state, ownProps) => {
  const isLoading = createIsLoading(OpenWebPromotionForm.dependencies);
  const didError = createDidError(OpenWebPromotionForm.dependencies);
  const owpJobSelector = createOpenWebJobSelector(ownProps.id);

  return {
    isAuthenticated: !!state.auth.session,
    isLoading: isLoading(state),
    didError: didError(state),
    job: owpJobSelector(state),
    company: state.jobs.company,
  }
};

export default connect(mapStateToProps, {
  get: getJobDetails,
  promoteOpenWebJob,
  getPostings,
  editContacts,
})(OpenWebPromotionForm);


// WEBPACK FOOTER //
// ./src/components/OWP/OpenWebPromotionForm.js